// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"b24dd593","189":"1aeafce7","212":"7e7839a4","556":"5e80e76a","636":"b24dd593","644":"b24dd593","712":"b24dd593","780":"b24dd593","822":"6e85e41c","840":"98611134"}[chunkId] + ".chunk.css";
};